<lms-dynamic-form
  class="group-data-form"
  [action]="group ? 'groups.edit' : 'groups.create'"
  [questionsService]="questionsService"
  [options]="{
    submitLabel: !group ? 'groups.add' : 'actions.saveChanges',
    disableCard: true
  }"
  [data]="data"
  (submit)="submit($event)"
>
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>

<lms-modal #dateConfirmModal>
  <div class="gl-popup__title">{{ 'groups.datePopup.title' | translate }}</div>
  <div class="gl-popup__close" (click)="closeModal()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text">
    {{ 'groups.datePopup.text1' | translate }}
    <b>{{ groupData?.startDate | date : 'mediumDate' : groupData?.timezone }}</b>
  </div>
  <div class="gl-popup__text" [innerHtml]="'groups.datePopup.text2' | translate"></div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="closeModal()"></gl-button>
    <gl-button color-primary [text]="'groups.add' | translate" (onClick)="confirmModal()"></gl-button>
  </div>
</lms-modal>

<lms-modal #bonusWarningModal size="small">
  <div class="gl-popup__title">{{ 'groups.bonus.warningModal.title' | translate }}</div>
  <div class="gl-popup__close" (click)="closeBonusWarningModal(false)">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__text" [innerHtml]="'groups.bonus.warningModal.message' | translate : { students: '10' }"></div>
  <div class="gl-popup__field">
    <gl-checkbox
      [id]="'students.edit_anonymize'"
      [label]="'groups.bonus.warningModal.noShowMessage' | translate"
      [checked]="isCheckedBonusModal"
      [attr.small]="true"
      (onChange)="onChange($event['detail']['value'])"
    >
    </gl-checkbox>
  </div>
  <div class="gl-popup__buttons">
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="closeBonusWarningModal(false)"
    ></gl-button>
    <gl-button
      color-primary
      [text]="'groups.bonus.warningModal.successBtn' | translate"
      (onClick)="closeBonusWarningModal(true)"
    ></gl-button>
  </div>
</lms-modal>
